export default {
  title: "CBAM Quick Search",
  subtitle: {
    noReg: "No registration required",
    free: "Free",
    minutes: "1 minute",
  },
  steps: {
    country: "Country",
    product: "Product",
    volume: "Import Volume",
    result: "Result",
  },
  step1: {
    title: "Are you importing from outside the EU to the EU, or trading within the EU?",
    outsideEU: "Import from outside EU",
    insideEU: "Within EU (exempted)",
  },
  step2: {
    title: "Main imported goods? (Multi-select support)",
    steel: "Steel",
    aluminum: "Aluminum",
    cement: "Cement",
    fertilizer: "Fertilizer",
    electricity: "Electricity",
    hydrogen: "Hydrogen",
    other: "Other",
  },
  step3: {
    title: "Estimated EU import volume in 2026?",
    lt50t: "< 50 tons (exempted)",
    between50_500t: "50–500 tons",
    gt500t: "> 500 tons",
  },
  result: {
    lowRisk: "Low Risk",
    mediumRisk: "Medium Risk",
    highRisk: "High Risk",
    insideEU:
      "Congratulations! EU internal trade is exempted, no reporting/payment required. But we recommend monitoring changes.",
    outsideEU:
      "Congratulations! Annual volume < 50 tons exemption or non-covered goods, no reporting/payment required. But we recommend monitoring changes.",
    highRiskDesc:
      "Must report + purchase certificates (based on emissions), error > 10% results in €1K–€10K fine.",
    mediumRiskDesc:
      "Quarterly reporting required, may pay starting 2026. We recommend generating PwC format report to mitigate risks.",
  },
  whyChoose: {
    title: "Why choose TaxEcoBit?",
    description:
      "TaxEcoBit helps you calculate with 90%+ accuracy, compliant PDF/Excel in 3 seconds.",
    features: {
      accurate: "Accurate compliance: Error <10%, meets CBAM requirements",
      fast: "Fast report: 3 seconds to generate compliant PDF/Excel",
      cost: "Cost advantage: €99/month, far below competitors €500+/month",
      trial: "Free trial for 14 days, experience all premium features",
    },
  },
  newRule:
    "New regulation in 2026: Annual < 50 tons exempted (except hydrogen/electricity), but reports still need precision to avoid fines.",
  buttons: {
    prev: "Previous",
    next: "Next",
    viewResult: "View Result",
    generateReport: "Generate Full Report (Free signup/trial)",
    restart: "Restart",
  },
};
